import React, { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { FilterBar } from "@/components/bi/FilterBar";
import { SlidersHorizontal } from "lucide-react";

// Sticky, touch-friendly filter panel for mobile viewers.
export function MobileFilterSheet({ filtersDef, values, onChange, onClearAll, publicToken, activeCount }) {
  const [open, setOpen] = useState(false);
  if (!filtersDef || filtersDef.length === 0) return null;
  return (
    <>
      <div className="fixed bottom-4 left-0 right-0 z-40 flex justify-center pointer-events-none">
        <Button data-testid="mobile-filter-fab" onClick={() => setOpen(true)}
          className="pointer-events-auto h-11 px-5 rounded-full shadow-xl bg-[color:var(--brand-ocean)] text-white text-sm">
          <SlidersHorizontal className="w-4 h-4 mr-2" />Filters
          {activeCount > 0 && (
            <span data-testid="mobile-filter-count" className="ml-2 inline-flex items-center justify-center min-w-[20px] h-5 px-1 rounded-full bg-white text-[color:var(--brand-ocean)] text-[11px] font-semibold">{activeCount}</span>
          )}
        </Button>
      </div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" data-testid="mobile-filter-sheet" className="max-h-[75vh] overflow-y-auto rounded-t-2xl bi-canvas">
          <SheetHeader className="text-left">
            <SheetTitle className="font-display text-base flex items-center justify-between">
              <span>Filters</span>
              <button data-testid="mobile-filter-clear" onClick={() => { onClearAll(); }} className="text-xs font-normal text-[color:var(--brand-ocean)]">Clear all</button>
            </SheetTitle>
          </SheetHeader>
          <div className="pt-2 pb-6 [&_button]:min-h-[40px] [&_input]:min-h-[40px]">
            <FilterBar filtersDef={filtersDef} values={values} onChange={onChange} publicToken={publicToken} onClearAll={onClearAll} vertical />
          </div>
          <Button data-testid="mobile-filter-apply" onClick={() => setOpen(false)} className="w-full h-11 bg-[color:var(--brand-ocean)] text-white rounded-xl">Done</Button>
        </SheetContent>
      </Sheet>
    </>
  );
}
